import { get, post } from '@api/request';

export async function processEx366({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/certificationlog/0/hb366`;
  let { body } = await post(authenticationToken, url, {});
  return body;
}

// export async function fetchEx366({appraisalService}, authenticationToken, { runID }) {
//   const url = `${baseUrl}/appraisal/certificationlog/hb366/${runID}`;
//   console.log(url);
//   let { body } = await get(authenticationToken, url);
//   console.log(body);
//   return body;
// }

export async function fetchEx366(
  { appraisalService },
  authenticationToken,
  { runID },
) {
  const url = `${appraisalService}/appraisal/certificationlog/hb366/${runID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEx366Listing(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/certificationlog/hb366`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEx366Properties(
  { appraisalService },
  authenticationToken,
  { runID },
) {
  const url = `${appraisalService}/appraisal/certificationlog/hb366/${runID}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
}
